export default __webpack_public_path__ + "static/media/E2BAuto-300x600-px.948dfd61.jpg";